import React from 'react'
import { Container, Menu, Header } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

import UserCard from './userCard'
import { getSelectedList } from '../utility'
import '../css/App.css'

class MobileViewList extends React.Component {
  render () {
    return (
      <Container className='main-container'>
        <div className='scrollable-menu'>
          <Header as='h3' textAlign='center'>
            IMG Summer'19
          </Header>
          <Menu fluid vertical>
            {getSelectedList().map((x, index) => {
              return (
                <Menu.Item as={NavLink} to={`/${index + 1}`} key={index}>
                  <UserCard
                    name={x['Name of the applicant']}
                    display={x['Display picture']}
                    year={x['Year']}
                  />
                </Menu.Item>
              )
            })}
          </Menu>
        </div>
      </Container>
    )
  }
}

export default MobileViewList
